import { addBreadcrumb } from '@sentry/angular';

export class AuthError extends Error {
  constructor(public readonly code?: string) {
    let errorMessage = '';
    addBreadcrumb({ message: `AuthError: ${code}`, level: 'info' });
    switch (code) {
      case 'auth/user-not-found':
        errorMessage = 'autherror.user.notfound';
        break;
      case 'auth/wrong-password':
        errorMessage = 'autherror.invalid.password';
        break;
      case 'auth/invalid-credential':
        errorMessage = 'autherror.invalid.credential';
        break;
      case 'auth/too-many-requests':
        errorMessage = 'autherror.request.toomany';
        break;
      case 'auth/user-disabled':
        errorMessage = 'autherror.user.disabled';
        break;
      case 'auth/invalid-email':
        errorMessage = 'autherror.invalid.email';
        break;
      case 'auth/invalid-action-code':
        errorMessage = 'autherror.invalid.actioncode';
        break;
      case 'auth/invalid-req-type':
        errorMessage = 'autherror.invalid.reqtype';
        break;
      case 'oob-code-expired':
        errorMessage = 'autherror.expired.oobcode';
        break;
      default:
        errorMessage = 'autherror.default';
    }
    super(errorMessage);
    this.name = 'AuthError';
    this.code = code;
    Object.setPrototypeOf(this, AuthError.prototype);
  }
}
